/* eslint-disable no-use-before-define */
import authenticatedBackendRequest from './authenticatedBackendRequest';
import { PbRequest } from '../pbRequest';
import { PbDispatch } from '../index';
import {
    pbRequestFailure,
    pbRequestStart,
    pbRequestSuccess,
} from '../pbRequestSlice';

export enum RequestStatus {
    INITIAL = 'INITIAL',
    PENDING = 'PENDING',
    FAILURE = 'FAILURE',
    SUCCESS = 'SUCCESS',
}

export const REQUEST_INITIAL = RequestStatus.INITIAL;
export const REQUEST_PENDING = RequestStatus.PENDING;
export const REQUEST_FAILURE = RequestStatus.FAILURE;
export const REQUEST_SUCCESS = RequestStatus.SUCCESS;
export const REQUEST_TECHNICAL_ISSUE = 'TECHNICAL_ISSUE';

export function isFinal(status: RequestStatus): boolean {
    return [RequestStatus.FAILURE, RequestStatus.SUCCESS].includes(status);
}

export interface ManagedRequest<T> {
    status: RequestStatus;
    errors: string[];
    data?: T;
}

export function processRequestAction<T>(
    url: string,
    request: RequestInit,
    identifier: PbRequest
) {
    return (dispatch: PbDispatch) =>
        processRequest<T>(dispatch, url, request, identifier);
}

export async function processRequest<T>(
    dispatch: PbDispatch,
    url: string,
    request: RequestInit,
    identifier: PbRequest
): Promise<T> {
    dispatch(pbRequestStart(identifier));
    try {
        const response = await authenticatedBackendRequest<T>(
            dispatch,
            url,
            request
        );
        dispatch(pbRequestSuccess(identifier));
        return response;
    } catch (err) {
        dispatch(pbRequestFailure(identifier, err.body?.tags ?? []));
        throw err;
    }
}
